import { useParams } from "react-router";

export const usePlanURL = (eventId?: string) => {
  const params = useParams()
  return `/plans/${eventId ?? params["eventId"]}`
}
